"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useDataLinkTableInstance(selector) {
  const {
    item: dataLinkTableInstance,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.DataLinkTableInstance,
    selector,
    (integrationApp) => selector ? integrationApp.dataLinkTableInstance(selector) : void 0
  );
  return {
    dataLinkTableInstance,
    accessor,
    refresh,
    findLinks: accessor?.findLinks,
    createLink: accessor?.createLink,
    deleteLink: accessor?.deleteLink,
    ...rest
  };
}

export { useDataLinkTableInstance };
